import React from 'react';
import { PersonalisedBrandsTags } from './personalised-brands-tags';
import { PersonalisedSearchesTags } from './personalised-searches-tags';
import css from './personalised-tags.module.scss';

export const PersonalisedTags = () => {
    return (
        <div className={`${css.wrapper} pt-md-5 pt-3 mx-md-3 mx-lg-2 mx-xl-0`}>
            <PersonalisedBrandsTags />
            <PersonalisedSearchesTags />
        </div>
    );
};
